import Vue from 'vue'
import App from './App.vue'
import vueDebounce from 'vue-debounce'
var VueScrollTo = require('vue-scrollto');
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import i18n from '../i18n'; // Import i18n

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}

Vue.prototype.$store = Vue.observable({
  debug: false,
  const: {
    SEARCH_STATE_READY: 0,
    SEARCH_STATE_SEARCHING: 1,
    SEARCH_STATE_NO_RESULTS: 2,
    SEARCH_STATE_ERROR: 3
  },
  state: {
    windowWidth: 0,
    selectedPhraseID: window.selectedPhraseID, // 1
    selectedLetter: window.selectedLetter, // null
    searchFocus: false,
    mobileDetailShown: true,
    preloaderShown: false,
  },
  log(input) {
    if(this.debug)
    {
      console.log(input);
    }
  },
  setWindowWidth (newValue) {
    if (this.debug) console.log('setWindowWidth triggered with', newValue)
    this.state.windowWidth = newValue
  },
  setPreloaderShown (newValue) {
    if (this.debug) console.log('setPreloaderShown triggered with', newValue)
    this.state.preloaderShown = newValue
  },
  setMobileDetailShown (newValue) {
    if (this.debug) console.log('setMobileDetailShown triggered with', newValue)
    this.state.mobileDetailShown = newValue
  },
  setSelectedPhraseID (newValue) {
    if (this.debug) console.log('setSelectedPhraseID triggered with', newValue)
    this.state.selectedPhraseID = newValue
  },
  setSelectedLetter (newValue) {
    if (this.debug) console.log('setSelectedLetter triggered with', newValue)
    this.state.selectedLetter = newValue
  },
  setSearchFocus (newValue) {
    if (this.debug) console.log('setSearchFocus triggered with', newValue)
    this.state.searchFocus = newValue
  }
})


Vue.use(PerfectScrollbar)

Vue.use(vueDebounce, {
  listenTo: 'input'
})
Vue.use(VueScrollTo)

new Vue({
  el: '#app',
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js